import { Box, styled } from '@lingoda/ui';
import { RouterLink, marketingWebPath } from '@lingoda/router';
import { LingodaLogo } from '@lingoda/logotype';

export const AuthHeader = () => {
    return (
        <HeaderStyled as="header">
            <ContainerStyled>
                <RouterLinkStyled onMouseDown={(e) => e.preventDefault()} to={marketingWebPath()}>
                    <Box sx={{ width: 135 }}>
                        <LingodaLogo />
                    </Box>
                </RouterLinkStyled>
            </ContainerStyled>
        </HeaderStyled>
    );
};

const HeaderStyled = styled(Box)(({ theme }) => {
    return {
        background: theme.colors.background.default,
        display: 'grid',
        alignItems: 'center',
        height: '64px',
    };
});

const ContainerStyled = styled(Box)(({ theme }) => {
    return {
        boxSizing: 'border-box',
        margin: '0 auto',
        maxWidth: 1364,
        padding: '0 32px',
        position: 'relative',
        width: '100%',
        display: 'grid',
        placeContent: 'center start',
        [theme.breakpoints.down('xl')]: { maxWidth: 1164 },
        [theme.breakpoints.down('lg')]: { maxWidth: 994 },
        [theme.breakpoints.down('md')]: {
            maxWidth: 978,
            padding: '0 24px',
            placeContent: 'center',
        },
        [theme.breakpoints.down('smw')]: { maxWidth: 748 },
        [theme.breakpoints.down('sm')]: { maxWidth: 588 },
    };
});

const RouterLinkStyled = styled(RouterLink)(() => ({
    display: 'inline-flex',
}));
